import PohCol from '@ui-kit/layout/Col';
import PohContainer from '@ui-kit/layout/Container';
import PohRow from '@ui-kit/layout/Row';

import ActualHikingWidget from './ActualHikingWidget';
import SubscribesCTA from './SubscribesCTA/SubscribesCTA';
import img from '../../img/tree1.png';

const Main = () => {
  return (
    <PohContainer>
      <title>Походники</title>
      <meta name="keywords" content="Походники" />
      <PohRow>
        <PohCol sm={5}>
          <img src={img} />
        </PohCol>
        <PohCol sm={7}>
          <div style={{ paddingTop: 80 }} />
          <ActualHikingWidget />
          <SubscribesCTA />
        </PohCol>
      </PohRow>
    </PohContainer>
  );
};

export default Main;
